/**
 * Format time in human-readable format
 * @param seconds - Number of seconds (can be decimal)
 * @returns Formatted time string
 *
 * Mise à jour pour être cohérent avec le nouveau calculateur backend
 */
export const formatTime = (seconds: number): string => {
  // Handle NaN, undefined, or invalid values
  if (!seconds || isNaN(seconds) || seconds <= 0) {
    return '0s';
  }

  // Arrondir les secondes pour éviter les décimales
  const roundedSeconds = Math.round(seconds);

  if (roundedSeconds < 60) {
    return `${roundedSeconds}s`;
  } else if (roundedSeconds < 3600) {
    const minutes = Math.floor(roundedSeconds / 60);
    const remainingSeconds = roundedSeconds % 60;
    if (remainingSeconds === 0) {
      return `${minutes}min`;
    }
    return `${minutes}min ${remainingSeconds}s`;
  } else {
    const hours = Math.floor(roundedSeconds / 3600);
    const remainingMinutes = Math.floor((roundedSeconds % 3600) / 60);
    if (remainingMinutes === 0) {
      return `${hours}h`;
    }
    return `${hours}h ${remainingMinutes}min`;
  }
};

/**
 * Format processing time in milliseconds
 * @param ms - Time in milliseconds
 * @returns Formatted time string
 */
export const formatProcessingTime = (ms: number): string => {
  if (!ms || isNaN(ms) || ms <= 0) {
    return '0ms';
  }

  if (ms < 1000) {
    return `${Math.round(ms)}ms`;
  }

  const seconds = Math.round(ms / 1000);
  return `${seconds}s`;
};
